import React from 'react';
import { useTranslation } from 'react-i18next';
import useOrganizationContact from '../../hooks/useOrganizationContact';
import { AccentLink, Text } from './PublicLegalPageLayout';

/** Exercice des droits RGPD — DPO + support (emails paramétrables). */
export default function PrivacyRightsContact({ introText }) {
  const { t } = useTranslation();
  const { organization, loading } = useOrganizationContact({ publicAccess: true });

  const intro = introText || t('privacyPage.rights.contactIntro');

  if (loading) {
    return (
      <Text>
        {intro} {t('common.loading')}
      </Text>
    );
  }

  return (
    <Text>
      {intro}{' '}
      <AccentLink href={organization.dpo.mailtoHref}>{organization.dpo.email}</AccentLink>
      {' '}
      {t('privacyPage.rights.contactOr')}{' '}
      <AccentLink href={organization.support.mailtoHref}>{organization.support.email}</AccentLink>
    </Text>
  );
}
